export default __webpack_public_path__ + "static/media/bg-Personas.d07a00f3.jpg";